import { TableCell, TableRow } from "@material-ui/core";
import {
	DatatablesFooterServerSide,
	Loading,
	TableAction,
} from "App/Component/ui";
import { getComparator, stableSort } from "App/Component/ui/datatable/utils";
import { useDatatables } from "App/hooks";
import { defaultDateDisplay } from "App/utils/helpers";
import { FreezeTable } from "components/organism";
import { StatusLokasi } from "pages/SatuSehat/utils";
import { deleteLokasi, headCells } from "./helpers";
import useModalDelete from "./hooks/useModalDelete";

export default function LokasiTable({
	rows,
	handleClickEdit,
	handleChildren,
	totalData,
	resetPagination,
	setNewData,
	pagination,
	onPrevious,
	onNext,
	handleClickPageNumber,
	handleChangeLimit,
	loading,
	handleChange,
	formFilter,
	setFormFilter,
	children,
}) {
	const { order, orderBy, handleRequestSort, length } = useDatatables({
		rows: rows,
		orderByDefault: "date",
		orderByRow: ["date", "id"],
	});
	const { ModalDelete, handleClickDelete } = useModalDelete({
		setNewData,
		children,
		handleClickYes: deleteLokasi,
	});

	return (
		<>
			<ModalDelete />

			<Loading show={loading} />

			<FreezeTable
				headCells={headCells}
				handleRequestSort={handleRequestSort}
				order={order}
				length={length}
				orderBy={orderBy}
			>
				{stableSort(rows, getComparator(order, orderBy)).map((row, index) => {
					return (
						<TableRow key={index}>
							<TableCell align="center">{index + 1}</TableCell>
							<TableCell align="center">
								<TableAction
									clickDelete={() => handleClickDelete(row.id_location)}
									clickUpdate={() => handleClickEdit(row)}
									isSelect={true}
									clickSelect={() => handleChildren(row)}
								/>
							</TableCell>
							<TableCell align="left">{row?.id}</TableCell>
							<TableCell align="left">{row?.kode}</TableCell>
							<TableCell align="left">{row?.name}</TableCell>
							<TableCell align="left">{row?.description}</TableCell>
							<TableCell align="center">
								<StatusLokasi status={row.status} />
							</TableCell>
							<TableCell align="left">{row?.mode}</TableCell>
							<TableCell align="left">{row?.type}</TableCell>
							<TableCell align="left">
								{defaultDateDisplay(row?.createdAt)}
							</TableCell>
							<TableCell align="left">{row?.createdBy}</TableCell>
							<TableCell align="left">
								{defaultDateDisplay(row?.updatedAt)}
							</TableCell>
							<TableCell align="left">{row?.updatedBy}</TableCell>
						</TableRow>
					);
				})}
				{rows.length === 0 && (
					<TableRow>
						<TableCell align="center" colSpan={headCells.length}>
							Tidak ada data
						</TableCell>
					</TableRow>
				)}
			</FreezeTable>

			<DatatablesFooterServerSide
				totalData={totalData}
				pagination={pagination}
				handleChangeLimit={handleChangeLimit}
				onPrevious={onPrevious}
				onNext={onNext}
				currentPage={pagination.page}
				handleClickPageNumber={handleClickPageNumber}
			/>
		</>
	);
}
